<template>
  <b-row>
    <!-- LEFT COLUMN: icon, title, description, and trial footer -->
    <b-col xs="12" md="6">
      <b-card>
        <b-col cols="12">
          <b-row>
            <b-col cols="12" class="heading-icon">
              <i :class="model.icon"></i>
              <h4>{{ $translateLabel(model.label) }}</h4>
            </b-col>
            <b-col cols="12">
              <p>
                {{ $t("integrations.minimax.description") }}
              </p>
            </b-col>
          </b-row>
        </b-col>

        <StartTrialFooter :integration="model" />
      </b-card>
    </b-col>

    <!-- RIGHT COLUMN: when active === true, show the settings form here -->
    <b-col sm="12" md="6">
      <b-card v-if="active">
        <b-col cols="12" v-if="true || $store.getters.getCurrentEnv == 'live'">
          <b-row>
            <b-col cols="12" class="heading-icon">
              <h5>Minimax Settings</h5>
            </b-col>

            <b-col cols="12">
              <!-- Error banner (optional) -->
              <b-alert
                v-if="error"
                variant="danger"
                show
                dismissible
                @dismissed="error = null"
              >
                {{ error }}
              </b-alert>
            </b-col>

            <b-col cols="12">
              <b-form @submit.prevent="saveSettings">
                <!-- Client ID -->
                <b-form-group label="Client ID" label-for="client-id-input">
                  <b-form-input
                    id="client-id-input"
                    v-model="client_id"
                    placeholder="Enter your Client ID"
                    required
                  />
                </b-form-group>

                <!-- Client Secret -->
                <b-form-group
                  label="Client Secret"
                  label-for="client-secret-input"
                >
                  <b-form-input
                    id="client-secret-input"
                    v-model="client_secret"
                    placeholder="Enter your Client Secret"
                    type="password"
                    required
                  />
                </b-form-group>

                <!-- Username -->
                <b-form-group label="Username" label-for="username-input">
                  <b-form-input
                    id="username-input"
                    v-model="username"
                    placeholder="Enter your Username"
                    required
                  />
                </b-form-group>

                <!-- Password -->
                <b-form-group label="Password" label-for="password-input">
                  <b-form-input
                    id="password-input"
                    v-model="password"
                    placeholder="Enter your Password"
                    type="password"
                    required
                  />
                </b-form-group>

                <b-button type="submit" variant="primary" :disabled="saving">
                  {{ saving ? "Saving..." : "Save Settings" }}
                </b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" v-else>
          <b-row>
            <b-col cols="12" class="heading-icon">
              <h5>Minimax Settings</h5>
            </b-col>
            <b-col cols="12">
              <p class="text-muted">
                {{ $t("integrations.minimax.minimax.settings_disabled") }}
              </p>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" class="mt-3">
          <p class="text-muted">
            {{ $t("integrations.minimax.minimax.integration_disclaimer") }}
          </p>
          <!-- EVERYTING IS LIVE -->
        </b-col>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
.heading-icon {
  text-align: center;
}
</style>

<script>
import Axios from "axios";
import StartTrialFooter from "../../StartTrialFooter";

export default {
  components: {
    StartTrialFooter,
  },
  props: {
    model: {
      type: Object,
      default: () => null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      client_id: "",
      client_secret: "",
      username: "",
      password: "",
      loading: false,
      saving: false,
      error: null,
      userId: null,
    };
  },
  computed: {
    projectUUID() {
      return this.$store.getters.getCurrentProject.uuid;
    },
  },
  watch: {
    active(newVal) {
      if (newVal) {
        this.getSettings();
      }
    },
  },
  created() {
    if (this.active) {
      this.getSettings();
    }
  },
  methods: {
    async getSettings() {
      this.loading = true;
      this.error = null;

      try {
        // const resp = await this.$integrationApi.get(
        //   `/karadjordje/minimax/settings`
        // );
        const resp = await Axios.get(
          `http://localhost:3001/v1/minimax/settings`,
          {
            headers: {
              "x-env": "dev",
              "x-project-uuid": this.projectUUID,
            },
          }
        );
        const { settings, userId } = resp.data || {};

        this.userId = userId;
        this.client_id = settings.client_id || "";
        this.client_secret = settings.client_secret || "";
        this.username = settings.username || "";
        this.password = settings.password || "";
      } catch (err) {
        console.error("Failed to fetch Minimax settings:", err);
        this.error =
          err.response.data.message ||
          err.message ||
          "Unable to load settings.";
      } finally {
        this.loading = false;
      }
    },

    async saveSettings() {
      if (
        !this.client_id ||
        !this.client_secret ||
        !this.username ||
        !this.password
      ) {
        this.error = "All fields are required.";
        return;
      }

      this.saving = true;
      this.error = null;

      const payload = {
        client_id: this.client_id,
        client_secret: this.client_secret,
        username: this.username,
        password: this.password,
      };

      try {
        // const resp = await this.$integrationApi.post(
        //   `/karadjordje/minimax/settings`,
        //   payload
        // );
        const resp = await Axios.post(
          `http://localhost:3001/v1/minimax/settings`,
          payload,
          {
            headers: {
              "x-env": "dev",
              "x-project-uuid": this.projectUUID,
            },
          }
        );
        const saved = resp.data || {};

        // Sync the form fields with what the server returned
        this.client_id = saved.client_id;
        this.client_secret = saved.client_secret;
        this.username = saved.username;
        this.password = saved.password;

        // Optionally show a success toast:
        // this.$bvToast.toast('Settings saved successfully.', { variant: 'success' })
      } catch (err) {
        console.error("Failed to save Minimax settings:", err);
        this.error =
          err.response.data.message ||
          err.message ||
          "Failed to save settings.";
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
